import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Dashboard from './views/Dashboard.vue';
import Map from './views/Map.vue';
import Locations from './views/Locations.vue';
import LocationsEdit from './views/LocationsEdit.vue';
import LocationsAdd from './views/LocationsAdd.vue';
import Terms from './views/Terms.vue';
import Announcements from './views/Announcements.vue';
import Bookings from './views/Bookings.vue';
import Logoff from './views/Logoff.vue';
import NotFound from './views/NotFound.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.API_BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        auth: false,
      },
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        auth: true,
      },
    },
    {
      path: '/map',
      name: 'map',
      component: Map,
      meta: {
        auth: true,
      },
    },
    {
      path: '/locations',
      name: 'locations',
      component: Locations,
      meta: {
        auth: true,
      },
    },
    {
      path: '/locations/edit/:id',
      name: 'locations.edit',
      component: LocationsEdit,
      meta: {
        auth: true,
      },
    },
    {
      path: '/locations/store',
      name: 'locations.store',
      component: LocationsAdd,
      meta: {
        auth: true,
      },
    },
    {
      path: '/ts-and-cs',
      name: 'ts-and-cs',
      component: Terms,
      meta: {
        auth: true,
      },
    },
    {
        path: '/announcements',
        name: 'announcements',
        component: Announcements,
        meta: {
            auth: true,
        },
    },
    {
      path: '/bookings',
      name: 'bookings',
      component: Bookings,
      meta: {
        auth: true,
      },
    },
    {
      path: '/logoff',
      name: 'logoff',
      component: Logoff,
      meta: {
        auth: true,
      },
    },
    {
      path: '*',
      name: 'notFound',
      component: NotFound,
    },
  ],
});
